import { useUserSessionStore } from '~/store/user-session'

export default defineNuxtRouteMiddleware((_to, _from) => {
  if (import.meta.client) {
    if (useAuth().status.value === 'authenticated') {
      useUserSessionStore().ensureSessionLoaded()
    }
  }
})
